import { createRoutes } from 'shared/hocs'

import { TournamentsOverview } from './overview'
import { TournamentsAdd } from './overview/components/add'
import { TournamentUpdate } from './overview/components/update'

export const Tournaments = createRoutes(({ match }) => [
  {
    exact: true,
    path: `${match.path}/add`,
    component: TournamentsAdd,
  },
  {
    path: `${match.path}/edit/:tournamentId`,
    component: TournamentUpdate,
  },
  {
    exact: true,
    path: match.path,
    component: TournamentsOverview,
  },
])
